import React from 'react';
import { Layout } from 'fronton-react';
import { COMMON_LANDINGS_IMAGES_CDN_PATH } from 'common/constants/common';
import { ButtonWithGAClickButton } from '../button';
import { Section } from '../section';
import { SectionSubTitle } from '../section-subtitle';
import { Typography } from '../typography';
import {
  calculatorPanelButton,
  calculatorPanelContent,
  calculatorPanelIcon,
  calculatorPanelSection,
  calculatorPanelText,
  calculatorPanelTitle,
  calculatorPanelWrapper,
} from './calculator-panel-styles';

type CalculatorPanelProps = {
  calculatoHref: string;
  description: string;
  elementBlock: string;
  elementName: string;
  title: string;
}

export const CalculatorPanel: React.FC<CalculatorPanelProps> = ({ description, calculatoHref, elementBlock, elementName, title }) => (
  <Section className={calculatorPanelSection}>
    <Layout>
      <div className={calculatorPanelWrapper}>
        <img
          className={calculatorPanelIcon}
          src={`${COMMON_LANDINGS_IMAGES_CDN_PATH}/calculator/calculator-icon.png/calculator-icon.png`}
          alt="Иконка калькулятора"
          width="116"
          height="88"
        />
        <div className={calculatorPanelContent}>
          <SectionSubTitle margin="s" className={calculatorPanelTitle}>
            {title}
          </SectionSubTitle>
          <Typography className={calculatorPanelText} variant="l" size="body_long">
            {description}
          </Typography>
        </div>
        <ButtonWithGAClickButton
          className={calculatorPanelButton}
          elementBlock={elementBlock}
          elementName={elementName}
          elementText="Рассчитать"
          href={calculatoHref}
          invert
          adaptive={false}>
          Рассчитать
        </ButtonWithGAClickButton>
      </div>
    </Layout>
  </Section>
);
